import request from '@/http/request'

export const getAllDropDownList = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/queryAllRsoDropDown`, params)
}

// overview report
export const getOverdueConfiguration = () => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/getOverDueConfiguration`)
}

export const getRsoOverviewReportList = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/queryRsoReport`, params)
}

export const downloadPdf = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/downloadPdfByBarCode`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const exportRsoReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/exportRsoReport`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

// detail report
export const getRsoDetaiReportlList = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/queryRsoDetailReport`, params)
}

export const exportRsoDetailReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/exportRsoDetailReport`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

// skip & reject rate report
export const getRsoRateReportlList = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/queryRsoRateReport`, params)
}

export const exportRsoRateReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid/v1/api/rso/exportRsoRateReport`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

// overdue validation
export const rsoValidate = rso => {
  return request.get(`${process.env.REACT_APP_RFID_API_URL}/rfid-postservice/out/api/rsoValidate?rso=${rso}`, {
    hiddenError: true
  })
}

export const unitOverdueValidate = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/rfid-postservice/out/api/unitOverdueValidate`, params, {
    hiddenError: true
  })
}
